import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AddAsectionsLayerList } from "../components/SECTION A/AddAsectionsLayerList";


export const AsectionsListPage = () => {
  return (
    <MasterLayout>
        <AddAsectionsLayerList />
    </MasterLayout>
  );
};
